const _temp0 = require("./icons/edit_item.svg");
const _temp1 = require("./icons/help.svg");
const _temp2 = require("./icons/open_chat.svg");
const _temp3 = require("./icons/regenerate_item.svg");
const _temp4 = require("./icons/trash.svg");
module.exports = {
  "edit_item": _temp0,
  "help": _temp1,
  "open_chat": _temp2,
  "regenerate_item": _temp3,
  "trash": _temp4
}